import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-player-daily',
  templateUrl: './player-daily.component.html',
  styleUrls: ['./player-daily.component.scss']
})
export class PlayerDailyComponent{

  public data:any = {};
  public str:string = "";
  public withdrawal:any;
  public is_loading = true;

  @Input() set setUserUUID(v:any) {
    this.init(v)
  }
  @Output() closeEvent = new EventEmitter();
  constructor(private http: HttpService, private route: ActivatedRoute, private clipboardApi: ClipboardService) { 
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    
    uuid.subscribe(val => {
      if(val) {
        this.init(val)
      }
    })
  }
  
  async init(uuid) {
    this.is_loading = true;
    this.data = await this.http.post('/admin/player/get/daily', {uuid});
    this.build();
    this.is_loading = false;
  }

  private inputValue: any = {};

  setWithdrawal($event) {
    this.inputValue.withdrawal = "\n Request Withdraw: " + $event.target.value
    this.build();
  }

  setGameID($event) {
    this.inputValue.GameID = "\n GAME ID: " + $event.target.value
    this.build();
  }

  setTotalBet($event) {
    this.inputValue.totalBet = "\n Total Bet: " + $event.target.value
    this.build();
  }
  
  setTotalBonus($event) {
    this.inputValue.totalBonus = "\n Total Bonus: " + $event.target.value
    this.build();
  }

  setGameBrand($event) {
    this.inputValue.gameBrand = "\n Game Brand: " + $event.target.value
    this.build();
  }

  setGameName($event) {
    this.inputValue.gameName = "\n Game Name: " + $event.target.value
    this.build();
  }

  setMinBet($event) {
    this.inputValue.minBet = "\n Min Bet: " + $event.target.value
    this.build();
  }

  setMaxBet($event) {
    this.inputValue.maxBet = "\n Max Bet: " + $event.target.value
    this.build();
  }

  build() {
    this.str = this.data.string.replace("PREAPPEND", (this.inputValue.GameID ?? "") + (this.inputValue.totalBet ?? "") + (this.inputValue.totalBonus ?? "") + (this.inputValue.gameBrand ?? "") + (this.inputValue.gameName ?? "")) + (this.inputValue.withdrawal ?? "") + (this.inputValue.minBet ?? "") + (this.inputValue.maxBet ?? "")
  }

  copy() {
    this.clipboardApi.copyFromContent(this.str)
    this.closeEvent.emit(true);
  }

  close() {
    this.closeEvent.emit(true);
  }
}
